import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { authActions } from '@mkp/auth/actions';
import { selectGdprFunctional } from '@mkp/gdpr/state';
import { TrackingActions } from '@mkp/tracking/state/actions';
import { Store } from '@ngrx/store';
import { getCurrentScope } from '@sentry/browser';
import { UserRole } from '@mkp/user/models';
import { selectIsUserRole, selectLoggedInUser } from '@mkp/user/state-logged-in/selectors';
import { filter, fromEvent, map, merge, take } from 'rxjs';

@Component({
  selector: 'mkp-root',
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AppComponent implements OnInit {
  private store = inject(Store);

  offline$ = getOfflineObservable();
  gdprFunctional$ = this.store.select(selectGdprFunctional);
  readonly isJcEmployee$ = this.store.select(selectIsUserRole(UserRole.JcEmployee));

  constructor() {
    this.store.dispatch(authActions.appBootstrapped());
  }

  ngOnInit() {
    this.setupSentry();
    this.store.dispatch(TrackingActions.loadTealiumStart());
  }

  private setupSentry(): void {
    this.store
      .select(selectLoggedInUser)
      .pipe(filter(Boolean), take(1))
      .subscribe(({ id, settings: { language } }) => getCurrentScope().setUser({ id, language }));
  }
}

const getOfflineObservable = () =>
  merge(fromEvent(window, 'online'), fromEvent(window, 'offline')).pipe(
    map(() => !navigator.onLine)
  );
